(() => {
  // Theme editor section replacements reuse this listener.
  if (window.articleInlineProductsInitialized) return;
  window.articleInlineProductsInitialized = true;

  const titleSelector = '.article-inline-products__title';
  const widths = new WeakMap();

  function fitTitle(title) {
    if (!title.isConnected || !title.clientWidth) return;
    title.style.removeProperty('font-size');
    const maximum = parseFloat(getComputedStyle(title).fontSize);
    const range = document.createRange();
    range.selectNodeContents(title);
    const available = title.clientWidth - 1;
    if (range.getBoundingClientRect().width <= available) return;

    // Measure the actual translated text in the loaded font, rather than
    // estimating its width from character count or the viewport size.
    let low = 0;
    let high = maximum;
    for (let i = 0; i < 12; i++) {
      const size = (low + high) / 2;
      title.style.fontSize = `${size}px`;
      if (range.getBoundingClientRect().width <= available) low = size;
      else high = size;
    }
    title.style.fontSize = `${Math.floor(low * 100) / 100}px`;
  }

  const observer = new ResizeObserver((entries) => {
    entries.forEach(({ target, contentRect }) => {
      if (widths.get(target) === contentRect.width) return;
      widths.set(target, contentRect.width);
      fitTitle(target);
    });
  });

  function fitTitles() {
    document.querySelectorAll(titleSelector).forEach(fitTitle);
  }

  function insertProducts(root) {
    root.querySelectorAll('template[data-article-inline-products]').forEach((template) => {
      const content = template.closest('.article-content');
      const body = content && content.querySelector('.article-body');
      const heading = body && body.querySelectorAll('h2')[1];
      if (!heading) return;

      heading.before(template.content.cloneNode(true));
      template.remove();
    });
    root.querySelectorAll(titleSelector).forEach((title) => {
      fitTitle(title);
      observer.observe(title);
    });
  }

  insertProducts(document);
  document.addEventListener('shopify:section:load', (event) => insertProducts(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll(titleSelector).forEach((title) => observer.unobserve(title));
  });
  if (document.fonts) {
    document.fonts.ready.then(fitTitles);
    document.fonts.addEventListener('loadingdone', fitTitles);
  }
})();
